<app-template>

    <div class="fad-desktop" *ngIf=" isMobile === false && isTablet === false ">
        <div class="principal-section">
            <div class="img-principal2"></div>
            <div class="side image-background">
                <div class="data">
                    <div class="title">
                        <p>Ótimo! Recebemos seus dados corretamente.
                            <br><br><span>Entraremos em contato com você, obrigado.</span></p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="fad-movil" *ngIf=" isMobile === true || isTablet === true ">

        <div class="box-container">

            <div class="fad-movil">
                <img src="assets/images/m/fadangel.png">
            </div>

            <div class="content-general">
                <p class="title-secondary"><span>Ótimo!</span><br>Recebemos <span>seus<br>dados <br>corretamente.</span></p>
                <p class="title-secondary">Entraremos em<br>contato com você, <br><span>obrigado.</span></p>
            </div>

        </div>

    </div>

</app-template>
